import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    SmallTablePlaceholder: {
        '& .TwoTables': {
            display: 'flex',
            alignItems: 'center',
            '& >div:nth-child(1)': {
                flex: 1,
            },
            '& >div:nth-child(2)': {
                margin: '0 5px'
            },
            '& >div:nth-child(3)': {
                flex: 1,
            }
        },
        '& .Table1': {
            display: 'flex',
            alignItems: 'center',
            '& .BackBtn': {
                border: 'none',
                background: 'none',
                boxShadow: 'none',
                marginRight: '14px',
                cursor: 'pointer'
    
            },
            '& .BackBtn + div': {
                flex: 1
            }
        },
    },
    TableDetails: {
        "background": "#FFFFFF",
        "border": "1px solid #e5e9f2",
        padding: '10px',
        display: 'flex',
        '& .TableIcon': {
            "width": "32px",
            "height": "32px",
            "background": "#e14954",
            "borderRadius": "8px",
            marginRight: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        '& .TableName': {
            marginRight: 'auto',
            '&>div:first-child': {
                "fontStyle": "normal",
                "fontWeight": "700",
                "fontSize": "12px",
                "lineHeight": "15px",
                "textTransform": "uppercase",
                "color": "#271D1C",
                marginBottom: '5px'
            },
            '&>div:last-child': {
                "fontWeight": "700",
                "fontSize": "8px",
                "lineHeight": "10px",
                "textTransform": "uppercase",
                "color": "rgba(39, 29, 28, 0.75)"
            }
        },
        '& .Actions': {
            color: '#6E7187',
            fontSize: '20px'
        }
    },
    ExchangeBtn: {
        "width": "24px",
        "height": "24px",
        "background": "#271D1C",
        borderRadius: '50%',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        '& img': {
            width: '15px'
        }
    },
}));
